import { makeStyles, Text, tokens } from "@fluentui/react-components";
import { Checkmark20Filled, CheckmarkCircle24Filled, CheckmarkCircle24Regular, CheckmarkRegular, } from "@fluentui/react-icons";
import * as React from 'react'


const useStyles = makeStyles({
    chip: {
        display: "flex",
        alignItems: "center",
        textAlign: "left",
        gap: "12px",
    },
    iconContainer: {
        backgroundColor: "#0A78D51f",
        borderRadius: "50%",
        height: "25px",
        width: "25px",
        alignContent: "center",
        textAlign: "center",
    },
    icon: {
        fontSize: "15px",
        color: "#0A78D5",
    },
    paragraph: {
        margin: 0,
        color: tokens.colorNeutralForeground3,
        fontSize: "12px",
    },
});


export default function CheckLabel({ label }: { label: string }) {
    return (
        <div className={useStyles().chip}>
            <CheckmarkCircle24Regular color={"#0A78D5"} />
            <Text as="p" className={useStyles().paragraph}>{label}</Text>
        </div>
    );
}